import * as cn from "./Item.scss"

import {LogItem} from "./parseResult"
import * as React from "react";

type Props = {
    item: LogItem
}

export class Item extends React.PureComponent<Props> {
    render() {
        const {item: {from, time, message}} = this.props

        return (
            <li className = {cn.component}>
                <p className = {cn.info}>
                    <span>{time.toLocaleString([], {hour: "numeric", minute: "numeric"})}</span>
                    <span className = {cn.from}>{" " + from}</span>
                </p>
                <p className = {cn.message}>{message}</p>
            </li>
        )
    }
}